import { getCursosByAnioDesc } from '@/api/cursos.api'
import { getLocalizaciones } from '@/api/localizaciones.api'

const state = {
  cursoActual: null,
  cursos: [],
  localizaciones: [],
}

const getters = {
  GET_CURSO_ACTUAL(state) {
    return state.cursoActual
  },

  GET_CURSOS(state) {
    return state.cursos
  },

  GET_LOCALIZACIONES(state) {
    return state.localizaciones
  },
}

const actions = {
  async INITIALIZE_CURSOS({ commit }) {
    let response = await getCursosByAnioDesc()
    let cursos = response.data
    let cursoActual = cursos[0]

    commit('SET_CURSO_ACTUAL', cursoActual)
    commit('SET_CURSOS', cursos)
  },

  async INITIALIZE_LOCALIZACIONES({ commit }) {
    let response = await getLocalizaciones()
    let localizaciones = response.data

    commit('SET_LOCALIZACIONES', localizaciones)
  },
}

const mutations = {
  SET_CURSO_ACTUAL(state, curso) {
    state.cursoActual = curso
  },

  SET_CURSOS(state, cursos) {
    state.cursos = cursos
  },

  SET_LOCALIZACIONES(state, localizaciones) {
    state.localizaciones = localizaciones
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
